import { Pipe, PipeTransform } from '@angular/core';
import { SafeResourceUrlService } from '../services/safe-resource-url.service';

@Pipe({
  name: 'safe',
  standalone: false,
})
export class SafePipe implements PipeTransform {
  constructor(private readonly safeResourceUrlService: SafeResourceUrlService) {}
  transform(url) {
    return this.safeResourceUrlService.toSafeUrl(url);
  }
}
